<section class="profile-page flex flex-col font-display w-full max-w-6xl mx-auto p-4 sm:p-6">
  <div class="page-header">
    <div class="min-w-0 flex-1">
      <p class="text-xs font-medium text-slate-500 mb-1">Akun</p>
      <h1 class="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
        Profil saya
      </h1>
      <p class="text-sm text-slate-500 mt-1">
        {{
          editForm
            ? "Perbarui data pribadi dan informasi rekening Anda."
            : "Lihat dan kelola informasi profil Anda."
        }}
      </p>
    </div>
    <div class="page-header__actions">
      <button
        *ngIf="!editForm"
        type="button"
        class="btn-primary"
        (click)="enableEdit()"
      >
        <i class="fa-solid fa-pen-to-square text-xs"></i>
        Edit profil
      </button>
      <button
        *ngIf="editForm"
        type="button"
        class="btn-danger"
        (click)="cancelEdit()"
      >
        Batal
      </button>
    </div>
  </div>

  <div class="profile-hero" *ngIf="profileData">
    <div class="profile-hero__main">
      <div class="profile-hero__avatar-wrap">
        <img
          [src]="imageUrl || 'profile.png'"
          alt="Foto profil"
          class="profile-hero__avatar"
        />
        <button
          *ngIf="editForm"
          type="button"
          class="profile-hero__avatar-btn"
          (click)="fileInput.click()"
          aria-label="Ubah foto"
        >
          <i class="fa-solid fa-camera text-xs"></i>
        </button>
        <input
          #fileInput
          type="file"
          class="hidden"
          accept="image/*"
          (change)="uploadFile($event)"
        />
      </div>
      <div class="min-w-0">
        <p class="profile-hero__name">{{ getFullName() }}</p>
        <p class="profile-hero__email">{{ profileData.email ?? "-" }}</p>
        <p
          *ngIf="editForm && fileName"
          class="text-xs text-slate-500 mt-1 truncate"
        >
          {{ fileName }}
        </p>
        <mat-spinner
          *ngIf="uploadStatus"
          [diameter]="24"
          class="mt-2"
        ></mat-spinner>
      </div>
    </div>
    <div class="profile-hero__meta">
      <span class="employee-badge"
        >ID karyawan {{ profileData.employeeId ?? "-" }}</span
      >
      <span class="role-badge">{{ getRolesLabel() }}</span>
    </div>
  </div>

  <form [formGroup]="form" class="flex flex-col gap-6">
    <div class="section-card">
      <div class="section-card__header">
        <span class="section-card__title">Data pribadi</span>
      </div>
      <div class="section-card__body">
        <div class="info-grid">
          <ng-container *ngIf="!editForm; else editPersonal">
            <div class="info-field">
              <span class="info-field__label">Nama depan</span>
              <span class="info-field__value">{{
                profileData?.firstName ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Nama belakang</span>
              <span class="info-field__value">{{
                profileData?.lastName ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Jenis kelamin</span>
              <span class="info-field__value">{{
                profileData?.gender ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">No. Identitas</span>
              <span class="info-field__value">{{
                profileData?.identityNumber ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tanggal lahir</span>
              <span class="info-field__value">{{
                formatDate(profileData?.birthDate)
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tempat lahir</span>
              <span class="info-field__value">{{
                profileData?.placeOfBirth ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Email</span>
              <span class="info-field__value">{{
                profileData?.email ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Telepon</span>
              <span class="info-field__value">{{
                profileData?.phone ?? "-"
              }}</span>
            </div>
          </ng-container>

          <ng-template #editPersonal>
            <div class="info-field">
              <span class="info-field__label">Nama depan</span>
              <input
                type="text"
                formControlName="first_name"
                class="form-input"
                [ngClass]="{
                  'form-input--error':
                    form.get('first_name')?.invalid &&
                    form.get('first_name')?.touched
                }"
               placeholder="Masukkan nama depan"/>
              <span
                *ngIf="
                  form.get('first_name')?.invalid &&
                  form.get('first_name')?.touched
                "
                class="field-error"
                >Nama depan wajib diisi</span
              >
            </div>
            <div class="info-field">
              <span class="info-field__label">Nama belakang</span>
              <input
                type="text"
                formControlName="last_name"
                class="form-input"
                [ngClass]="{
                  'form-input--error':
                    form.get('last_name')?.invalid &&
                    form.get('last_name')?.touched
                }"
               placeholder="Masukkan nama belakang"/>
              <span
                *ngIf="
                  form.get('last_name')?.invalid &&
                  form.get('last_name')?.touched
                "
                class="field-error"
                >Nama belakang wajib diisi</span
              >
            </div>
            <div class="info-field">
              <span class="info-field__label">Jenis kelamin</span>
              <div class="select-field">
                <mat-select formControlName="gender" placeholder="Pilih jenis kelamin">
                  <mat-option value="Laki-laki">Laki-laki</mat-option>
                  <mat-option value="Perempuan">Perempuan</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="info-field">
              <span class="info-field__label">No. Identitas</span>
              <input
                type="text"
                formControlName="identity_number"
                class="form-input"
               placeholder="Masukkan nomor identitas"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tanggal lahir</span>
              <input type="date" formControlName="date_birth" class="form-input"  placeholder="Pilih tanggal lahir"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tempat lahir</span>
              <input
                type="text"
                formControlName="place_birth"
                class="form-input"
               placeholder="Masukkan tempat lahir"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Email</span>
              <input type="email" formControlName="email" class="form-input"  placeholder="Masukkan email"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Telepon</span>
              <input type="text" formControlName="phone" class="form-input"  placeholder="Masukkan nomor telepon"/>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card__header">
        <span class="section-card__title">Data kepegawaian</span>
      </div>
      <div class="section-card__body">
        <div class="info-grid">
          <ng-container *ngIf="!editForm; else editEmployment">
            <div class="info-field">
              <span class="info-field__label">ID karyawan</span>
              <span class="info-field__value">{{
                profileData?.employeeId ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Posisi</span>
              <span class="info-field__value">{{
                profileData?.position ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Status kepegawaian</span>
              <span class="info-field__value">{{
                profileData?.statusEmployment ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Team</span>
              <span class="info-field__value">{{
                profileData?.team?.name ?? "-"
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tanggal bergabung</span>
              <span class="info-field__value">{{
                formatDate(profileData?.joinDate)
              }}</span>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tanggal berakhir</span>
              <span class="info-field__value">{{
                formatDate(profileData?.endDate)
              }}</span>
            </div>
            <div class="info-field info-field--full">
              <span class="info-field__label">Role</span>
              <span class="info-field__value">{{ getRolesLabel() }}</span>
            </div>
            <div class="info-field info-field--full">
              <span class="info-field__label">Maks. cash advance</span>
              <span class="info-field__value">{{
                profileData?.maximumAmount
                  ? (profileData.maximumAmount
                    | currency : "IDR" : "symbol" : "1.0-0")
                  : "-"
              }}</span>
            </div>
          </ng-container>

          <ng-template #editEmployment>
            <div class="info-field">
              <span class="info-field__label">ID karyawan</span>
              <input
                type="text"
                formControlName="employee_id"
                class="form-input"
               placeholder="Masukkan ID karyawan"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Posisi</span>
              <div class="select-field">
                <mat-select formControlName="position" placeholder="Pilih posisi">
                  <mat-option
                    *ngFor="let item of positions"
                    [value]="item.name"
                    >{{ item.name }}</mat-option
                  >
                </mat-select>
              </div>
            </div>
            <div class="info-field">
              <span class="info-field__label">Status kepegawaian</span>
              <input
                type="text"
                formControlName="statusEmployment"
                class="form-input"
               placeholder="Masukkan status kepegawaian"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Team</span>
              <div class="select-field">
                <mat-select formControlName="teamId" placeholder="Pilih team">
                  <mat-option *ngFor="let item of teams" [value]="item.id">{{
                    item.name
                  }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tanggal bergabung</span>
              <input
                type="date"
                formControlName="join_date"
                class="form-input"
               placeholder="Pilih tanggal bergabung"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Tanggal berakhir</span>
              <input type="date" formControlName="end_date" class="form-input"  placeholder="Pilih tanggal berakhir"/>
            </div>
            <div class="info-field info-field--full">
              <span class="info-field__label">Role</span>
              <span class="info-field__value info-field__value--static">{{
                getRolesLabel()
              }}</span>
            </div>
            <div class="info-field info-field--full">
              <span class="info-field__label">Maks. cash advance</span>
              <input
                type="text"
                formControlName="max_amount_cash_advance"
                class="form-input"
               placeholder="Masukkan maks. cash advance"/>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card__header">
        <span class="section-card__title">Informasi rekening</span>
      </div>
      <div class="section-card__body">
        <ng-container *ngIf="!editForm; else editBank">
          <div class="bank-grid">
            <div class="bank-item">
              <span class="bank-item__label">Bank</span>
              <span class="bank-item__value">{{
                profileData?.bankName ?? "-"
              }}</span>
            </div>
            <div class="bank-item">
              <span class="bank-item__label">Atas nama</span>
              <span class="bank-item__value">{{
                profileData?.bankAccountName ?? "-"
              }}</span>
            </div>
            <div class="bank-item">
              <span class="bank-item__label">No. Rekening</span>
              <span class="bank-item__value">{{
                profileData?.bankAccountNumber ?? "-"
              }}</span>
            </div>
          </div>
        </ng-container>

        <ng-template #editBank>
          <div class="info-grid">
            <div class="info-field">
              <span class="info-field__label">Bank</span>
              <input type="text" formControlName="bank_name" class="form-input"  placeholder="Masukkan nama bank"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">Atas nama</span>
              <input
                type="text"
                formControlName="bank_account_name"
                class="form-input"
               placeholder="Masukkan nama pemilik rekening"/>
            </div>
            <div class="info-field">
              <span class="info-field__label">No. Rekening</span>
              <input
                type="text"
                formControlName="bank_account_number"
                class="form-input"
               placeholder="Masukkan nomor rekening"/>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="section-card" *ngIf="editForm">
      <div class="section-card__header">
        <span class="section-card__title">Keamanan akun</span>
      </div>
      <div class="section-card__body">
        <div class="info-grid">
          <div class="info-field">
            <span class="info-field__label">Password baru</span>
            <input
              type="password"
              formControlName="password"
              class="form-input"
              placeholder="Kosongkan jika tidak diubah"
            />
          </div>
          <div class="info-field">
            <span class="info-field__label">Konfirmasi password</span>
            <input
              type="password"
              formControlName="re_enter_password"
              class="form-input"
              [ngClass]="{
                'form-input--error':
                  form.get('re_enter_password')?.value &&
                  form.get('re_enter_password')?.value !==
                    form.get('password')?.value
              }"
             placeholder="Masukkan ulang password baru"/>
            <span
              *ngIf="
                form.get('re_enter_password')?.value &&
                form.get('re_enter_password')?.value !== form.get('password')?.value
              "
              class="field-error"
              >Password tidak cocok</span
            >
          </div>
        </div>
        <div class="form-actions">
          <button type="button" class="btn-primary" (click)="submit()">
            <i class="fa-solid fa-floppy-disk text-xs"></i>
            Simpan perubahan
          </button>
          <button type="button" class="btn-danger" (click)="cancelEdit()">
            Batal
          </button>
        </div>
      </div>
    </div>
  </form>
</section>
